import { createBatchQueue } from '@wix/fe-essentials-viewer-platform/bi'

export function createForwardingBiQueue() {
	const queue = createBatchQueue() as any

	// Override feed to immediately forward each event to the main thread via postMessage.
	// Events have all defaults already resolved (global batch queue behavior).
	queue.feed = function (event: any, context: any) {
		self.postMessage({
			type: 'workerBiEvent',
			data: { event, context },
		})
		return Promise.resolve()
	}

	// No-op flush — events are already forwarded individually by feed()
	queue.flush = function () {
		return Promise.resolve()
	}

	return queue
}
